import React from 'react'
import { useMediaQueryCustom } from '../../../hooks/useMediaQueryCustom/useMediaQueryCustom';
import { Typography, } from "@gti-controls-v2/web-core";
import { fontSize } from '../../../common/constants/UI';

export const ConsumoPorTipo = ({ tipo = "Tipo", cantidad = "0" }) => {

    const { isMobile480, isTablet768, isTablet1024, isLaptopDesktop } = useMediaQueryCustom();

    return (
        <>
            <Typography 
                sx={isLaptopDesktop ? { lineHeight: 1.8 } : ""} 
                noWrap={ (isMobile480 || isTablet768) ? true : false }
                fontSize={ (isMobile480 || isTablet768 || isTablet1024) ? fontSize.isMobile480 : fontSize.isLaptopDesktop} color="#828282">
                {tipo}
            </Typography>
            
            <Typography 
                sx={isLaptopDesktop ? { lineHeight: 1.8 } : ""}
                fontSize={ (isMobile480 || isTablet768 || isTablet1024) ? fontSize.isMobile480 : fontSize.isLaptopDesktop}>
                {cantidad}
            </Typography>
        </>
    )
}
